import { DEMO_PEOPLE, type DemoPerson } from "./fixtures/demoTasks";

/** A demo record's number (`task-12` is 12), to pick its viewers the same way every run. */
const getDemoNumber = (id: string) => Number(/\d+$/.exec(id)?.[0] ?? 0);

/** A demo person as a user: `person-3` is user 3, as on Work rows (`getDemoWorkUserId`). */
export const toDemoUser = (person: DemoPerson) => ({
    ...person,
    id: getDemoNumber(person.id),
});

/**
 * Who else has a demo record open now: nobody on most cards, one person on
 * some and two on a few, so stacks of every size show.
 */
export const getDemoViewers = (id: string) => {
    const number = getDemoNumber(id);
    const viewers = number % 3 === 1 ? [DEMO_PEOPLE[(number + 1) % 5]] : [];
    return (
        number % 5 === 1 ? [...viewers, DEMO_PEOPLE[(number + 3) % 5]] : viewers
    ).map(toDemoUser);
};
